import { Fragment, h } from "preact";
import { RouterProps, useRouter } from "preact-router";
import { useBodyStyle } from "../hooks";
import { Container, Spacer } from "../material";
import { formatCurrency } from "../services/utils";
import { Button, LinkButton } from "../material/button";
import { getCategoryUrl, getProductUrl } from "../services/navigation";
import { useData, type Product } from "../services/data";
import { useShoppingBasket } from "../services/shoppingbasket";
import "./categorypage.scss";
import { Categories } from "./categories";

export function CategoryPage(props: RouterProps) {
    useBodyStyle("material");
    const data = useData();

    const [ctx] = useRouter();
    const categoryId = ctx.matches?.id;

    const category = data.categories.find(n => n.id == categoryId);
    const categoryproducts = data.products.filter(n => category && -1 !== category!.productIds.indexOf(n.id));

    return (
        <Container class="column grow">
            <Container class="grow column categorypage">
                {
                    category && category.images[0] &&
                    <div class="categoryimage" style={{ backgroundImage: "url(" + category.images[0] + ")" }}>
                        <br />
                    </div>
                }
                <Categories categories={data.categories} categoryId={categoryId!} />
                <div class="categoryproducts">
                    {
                        categoryproducts.map(product => <CategoryProductView product={product} />)
                    }
                </div>
            </Container>
        </Container>

    );
}

export function CategoryProductView(props: { product: Product }) {
    const { setOrIncrementProductCount } = useShoppingBasket();
    return (
        <div class="categoryproduct">
            <a href={getProductUrl(props.product)}>
                <div>
                    {
                        props.product.images[0] &&
                        <img src={props.product.images[0]} />
                    }
                </div>
            </a>
            <div>
                <h2><a href={getProductUrl(props.product)}>{props.product.title}</a></h2>
                {
                    !!props.product.description &&
                    <p>{props.product.description.length < 100 ? props.product.description : (props.product.description.substring(0, 101) + "...")}</p>
                }
                <Spacer />
                {
                    !!props.product.dayPrice &&
                    <div>
                        Pris: {formatCurrency(props.product.dayPrice)}
                    </div>
                }
                {
                    // <Button class="wide" onClick={() => setOrIncrementProductCount(props.product, undefined, 1)}>Tilføj</Button>
                }
                <LinkButton class="wide" href={getProductUrl(props.product)}>Se produkt</LinkButton>
            </div>
        </div>
    )
}
